module.exports = __webpack_public_path__ + "static/media/pr.ef813d85.webp";